import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './PriceCheckLink.less';
import { navigateTo, TAB } from '../../../Navigation/Menu/menuConfig';
import tracking from '../../../../tracking/tracking';
import { RLE_BANNER_NEW } from '../../../../tracking/trackingNaming';
import actions from '../../actions';

interface PriceCheckLinkProps {
  icon: string;
  text: string;
  value: string;
  priceCheckUpdateRealEstateType?: (realEstateType: string) => undefined;
}

// eslint-disable-next-line object-curly-newline
const PriceCheckLink = ({ icon, text, value, priceCheckUpdateRealEstateType }: PriceCheckLinkProps) => {
  const navigate = useNavigate();
  const handleClick = (realEstateType: string) => {
    tracking.report(RLE_BANNER_NEW);
    if (priceCheckUpdateRealEstateType) {
      priceCheckUpdateRealEstateType(realEstateType);
    }
    navigateTo(navigate, TAB.priceCheck);
  };

  return (
    <button
      type="button"
      className={`grid grid-flex grid-fill-rows padding-horizontal-none grid-align-center ${styles.priceCheckLinkContainer}`}
      onClick={() => handleClick(value)}
    >
      <div className="grid-item grid-item-fixed-width">
        <div className="indicator indicator--brand" role="presentation">
          <span className={`${icon} ${styles.icon} font-regular font-xl`} />
        </div>
      </div>
      <div className="grid-item one-half padding-left font-s">
        <span>{text}</span>
      </div>
      <div className="grid-item grid-item-fixed-width">
        <span className="is24-icon-chevron-right font-l float-right" />
      </div>
    </button>
  );
};

PriceCheckLink.defaultProps = {
  priceCheckUpdateRealEstateType: () => undefined,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  priceCheckUpdateRealEstateType: (realEstateType: string) => {
    const realEstateType2 = realEstateType;
    return actions.priceCheckRealEstateType(realEstateType2);
  },
};

/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
/* @ts-ignore */
export default connect(mapStateToProps, mapDispatchToProps)(PriceCheckLink);
